import { createFeatureSelector } from '@ngrx/store';

export const onlineMenuVirtualLocationsState = createFeatureSelector<OLO.State, OLO.State.OnlineMenuVirtualLocation[]>('onlineMenuVirtualLocations');
